<template>
    <el-dialog class="mediatbook" :title="diatorTitle" :close-on-click-modal=false :visible.sync="dialogVisible" :before-close="mediatbookClose" width="880px">
        <i v-if="formtype" class="dialog_edit_icon" @click="formStatus"></i>
        <div v-if="dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&& medbookbVisual">
            <div class="md-otwrap">
                <el-form :model="promiseResponse" ref="promiseForm" label-width="auto">
                <el-form-item :label="'申请人：'+promiseResponse.applicantName" label-width="auto" prop="applicantContent"
                    :rules="[
                        { required: true, message: '请填写详细内容', trigger: 'blur' }
                    ]">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="promiseResponse.applicantContent" readonly placeholder="请填写详细内容"></el-input>
                </el-form-item>
                <el-form-item :label="'被申请人：'+promiseResponse.respondentName" label-width="auto" prop="respondentContent"
                    :rules="[
                        { required: true, message: '请填写详细内容', trigger: 'blur' }
                    ]">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="promiseResponse.respondentContent" placeholder="请填写详细内容"></el-input>
                </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" @click="savePromiseBook('promiseForm')" class="meeting_button_primary" :disabled="buttonStatus">下一步，填写调解方案</el-button><el-button class="meeting_button_default" type="primary" @click="closeCurDialog">取消</el-button>
            </div>
        </div>
        <div v-if="dialogType == 'MEDIATION_BOOK'|| dialogType == 'UNDISPUTED_FACT' || dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&&!medbookbVisual">
            <el-form :model="protocolBookData" ref="ruleForm" label-width="100px" class="demo-ruleForm" size="small" :disabled="formtype">
                <div class="caseno"><el-input placeholder="请输入内容" :disabled="true" v-model="protocolBookData.caseNo" size="small"></el-input> 号</div>
                <div class="applicanlistscroll">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="md-head"><span>申请方</span></div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="md-head"><span>被申请方</span></div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.applicantList" :key="'applicant-'+index">
                                    <el-form-item :label="protocolBookData.applicantList.length>1?('申请人'+(index+1)):'申请人'"
                                        :prop="'applicantList.'+index+'.userName'"
                                        :rules="[
                                            { required: false, message: '请输入申请人姓名', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.userName" placeholder="请输入申请人姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'" label="法定代表人"
                                        :prop="'applicantList.'+index+'.corporation'"
                                        :rules="[
                                            { required: false, message: '请输入法定代表人', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.corporation" placeholder="请输入法定代表人"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='UNINCORPORATED_ORGANIZATION'" label="机构代表人"
                                        :prop="'applicantList.'+index+'.corporation'"
                                        :rules="[
                                            { required: false, message: '请输入机构代表人', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.corporation" placeholder="请输入机构代表人"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'||item.userType=='UNINCORPORATED_ORGANIZATION'" label="社会信用代码"
                                        :prop="'applicantList.'+index+'.creditCode'"
                                        :rules="[
                                            { required: false, message: '请输入社会信用代码', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.creditCode" placeholder="请输入社会信用代码"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="formaddress[item.userType]"
                                    :prop="'applicantList.'+index+'.address'"
                                    :rules="{ required: true, message: '请选择地址', trigger: 'blur' }">
                                        <area-search :comtransmit="{'index': index,'type':'app'}" :addressCodeName="allApplicantCodeName[index]" :getDetailAddress ="detailApplicantAddress[index]" @addressData="comAreaBack"  v-model="item.address"></area-search>
                                    </el-form-item>
                                    <el-form-item label="身份证号"
                                    :prop="'applicantList.'+index+'.idCard'"
                                    :rules="[
                                        { required: false, message: '请输入身份证号', trigger: 'blur' },
                                        { len: 18, message: '请输入18位身份证号', trigger: 'blur' },
                                        { pattern: /^\d{17}[\d|x|X]{1}$/, message: '身份证号不正确', trigger: 'blur'}
                                    ]">
                                        <el-input v-model="item.idCard" placeholder="请输入身份证号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别" prop="sex">
                                        <el-radio-group v-model="item.sex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.appAgentList" :key="'appAgent-'+index">
                                    <el-form-item label="代理人"
                                        :prop="'applicantList.'+index+'.agentName'"
                                        :rules="[
                                            { required: false, message: '请输入代理人姓名', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.agentName" placeholder="请输入代理人姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系电话"
                                        :prop="'applicantList.'+index+'.agentPhone'"
                                        :rules="[
                                            { required: false, message: '请输入代理人电话', trigger: 'blur' },
                                            { len: 11, message: '请输入11位手机号', trigger: 'blur' },
                                            { pattern: /^1[3-9]\d{9}$/, message: '手机号输入错误', trigger: 'blur'}
                                        ]">
                                        <el-input v-model="item.agentPhone" maxlength="11" placeholder="请输入代理人电话"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号"
                                    :prop="'applicantList.'+index+'.agentIdCard'"
                                    :rules="[
                                        { required: false, message: '请输入代理人身份证号', trigger: 'blur' },
                                        { len: 18, message: '请输入18位身份证号', trigger: 'blur' },
                                        { pattern: /^\d{17}[\d|x|X]{1}$/, message: '身份证号不正确', trigger: 'blur'}
                                    ]">
                                        <el-input v-model="item.agentIdCard" placeholder="请输入代理人身份证号"></el-input>
                                    </el-form-item>

                                    <el-form-item label="性别"
                                    :prop="'applicantList.'+index+'.agentSex'"
                                    :rules="[
                                        { required: false, message: '请选择性别', trigger: 'blur' },
                                    ]">
                                        <el-radio-group v-model="item.agentSex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="联系地址"
                                        :prop="'applicantList.'+index+'.agentAddress'"
                                        :rules="[
                                            { required: false, message:'请输入联系地址', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.agentCompany" placeholder="请输入联系地址"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.respondentList" :key="'respondent-'+index">
                                    <el-form-item :label="protocolBookData.respondentList.length>1?('被申请人'+(index+1)):'被申请人'"
                                        :prop="'respondentList.'+index+'.userName'"
                                        :rules="[
                                            { required: false, message: '请输入被申请人姓名', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.userName" placeholder="请输入被申请人姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'" label="法定代表人"
                                        :prop="'respondentList.'+index+'.corporation'"
                                        :rules="[
                                            { required: false, message: '请输入法定代表人', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.corporation" placeholder="请输入法定代表人"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='UNINCORPORATED_ORGANIZATION'" label="机构代表人"
                                        :prop="'respondentList.'+index+'.corporation'"
                                        :rules="[
                                            { required: false, message: '请输入机构代表人', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.corporation" placeholder="请输入机构代表人"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'||item.userType=='UNINCORPORATED_ORGANIZATION'" label="社会信用代码"
                                        :prop="'respondentList.'+index+'.creditCode'"
                                        :rules="[
                                            { required: false, message: '请输入社会信用代码', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.creditCode" placeholder="请输入社会信用代码"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="formaddress[item.userType]"
                                    :prop="'respondentList.'+index+'.address'"
                                    :rules="{ required: true, message: '请选择地址', trigger: 'blur' }">
                                        <area-search :comtransmit="{'index': index,'type':'res'}" :addressCodeName="allResCodeName[index]" :getDetailAddress ="detailResAddress[index]" @addressData="comAreaBack"  v-model="item.address"></area-search>
                                    </el-form-item>
                                    <el-form-item label="身份证号"
                                    :prop="'respondentList.'+index+'.idCard'"
                                    :rules="[
                                        { required: false, message: '请输入身份证号', trigger: 'blur' },
                                        { len: 18, message: '请输入18位身份证号', trigger: 'blur' },
                                        { pattern: /^\d{17}[\d|x|X]{1}$/, message: '身份证号不正确', trigger: 'blur'}
                                    ]">
                                        <el-input v-model="item.idCard" placeholder="请输入身份证号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别" prop="sex">
                                        <el-radio-group v-model="item.sex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.resAgentList" :key="'resAgent-'+index">
                                    <el-form-item label="代理人"
                                        :prop="'respondentList.'+index+'.agentName'"
                                        :rules="[
                                            { required: false, message: '请输入代理人姓名', trigger: 'blur' }
                                        ]">
                                        <el-input v-model="item.agentName" placeholder="请输入代理人姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系电话"
                                        :prop="'respondentList.'+index+'.agentPhone'"
                                        :rules="[
                                            { required: false, message: '请输入代理人电话', trigger: 'blur' },
                                            { len: 11, message: '请输入11位手机号', trigger: 'blur' },
                                            { pattern: /^1[3-9]\d{9}$/, message: '手机号输入错误', trigger: 'blur'}
                                        ]">
                                        <el-input v-model="item.agentPhone" maxlength="11" placeholder="请输入代理人电话"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号"
                                    :prop="'respondentList.'+index+'.agentIdCard'"
                                    :rules="[
                                        { required: false, message: '请输入代理人身份证号', trigger: 'blur' },
                                        { len: 18, message: '请输入18位身份证号', trigger: 'blur' },
                                        { pattern: /^\d{17}[\d|x|X]{1}$/, message: '身份证号不正确', trigger: 'blur'}
                                    ]">
                                        <el-input v-model="item.agentIdCard" placeholder="请输入代理人身份证号"></el-input>
                                    </el-form-item>

                                    <el-form-item label="性别"
                                    :prop="'respondentList.'+index+'.agentSex'"
                                    :rules="[
                                        { required: false, message: '请选择性别', trigger: 'blur' },
                                    ]">
                                        <el-radio-group v-model="item.agentSex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input v-model="item.agentCompany" placeholder="请输入联系地址"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div v-if="dialogType == 'MEDIATION_BOOK'">
                        <div class="md-otwrap">
                            <el-form-item label="纠纷主要事实，争议事项：" label-width="auto" prop="content"
                            :rules="[
                                { required: true, message: '请填写详细内容', trigger: 'blur' }
                            ]">
                                <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" v-model="protocolBookData.content" placeholder="请填写详细内容"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div v-if="dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&& !medbookbVisual">
                        <div class="md-otwrap">
                            <el-form-item label="当事人已书面同意本调解组织适用无异议调解认可制度。先就本纠纷提出以下调解方案：" label-width="auto" class="label_textalign" prop="content"
                            :rules="[
                                { required: true, message: '请填写详细内容', trigger: 'blur' }
                            ]">
                            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="protocolBookData.content" placeholder="请填写详细内容"></el-input>
                            </el-form-item>
                            <label class="label_other">{{protocolBookData.extendJson}}</label>
                        </div>
                    </div>
                    <div v-if="dialogType == 'UNDISPUTED_FACT'">
                        <div class="md-otwrap">
                            <el-form-item label="调解过程：" label-width="auto" prop="content"
                            :rules="[
                                { required: true, message: '请填写详细内容', trigger: 'blur' }
                            ]">
                                <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" v-model="protocolBookData.content" placeholder="请填写详细内容"></el-input>
                            </el-form-item>
                            <el-form-item label="经调解，当事人无争议的事实如下：" label-width="auto" prop="extendJson"
                            :rules="[
                                { required: true, message: '请填写详细内容', trigger: 'blur' }
                            ]">
                                <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" v-model="protocolBookData.extendJson" placeholder="请填写详细内容"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <div class="help-mediator" v-if="resdata.length > 0">
                    协助调解员签名:
                    <el-checkbox-group v-model="helpMediatorCheckList">
                        <el-checkbox :label="item" :key="item.userId" v-for="item in resdata">{{item.userName}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-if="Boolean(sendButtonStatus=='SEND_YES')" class="signstatus">
                    <el-button v-for="(item,index) in protocolBookData.confirmList" :key="index"
                        :type="item.confirmStatus=='SIGN_YES'||item.confirmStatus=='SIGN_YES_AGENT'?'success':item.confirmStatus == 'SIGN_NO'||item.confirmStatus == 'SIGN_NO_AGENT' ? 'danger' : 'warning'"
                        :icon="item.confirmStatus=='SIGN_YES'||item.confirmStatus=='SIGN_YES_AGENT'?'el-icon-success':item.confirmStatus=='SIGN_NO'||item.confirmStatus == 'SIGN_NO_AGENT' ? 'el-icon-error' : 'el-icon-question'"
                        size="mini" plain>{{item.confirmStatus=='SIGN_YES_AGENT'||item.confirmStatus == 'SIGN_NO_AGENT'?item.userName+'(代)':item.userName}}</el-button>
                </div>
                <el-button v-if="formtype&&Boolean(sendButtonStatus=='SEND_YES')" type="primary" class="meeting_button_primary" :disabled="buttonStatus">已发送</el-button>
                <el-button v-else type="primary" @click="sendBookForm('ruleForm')" class="meeting_button_primary" :loading="BtnLoading" :disabled="buttonStatus">{{sendButtonStatus=='SEND_YES'?'已发送':'发送'}}</el-button>
                <el-button v-if="formtype&&!Boolean(sendButtonStatus=='SEND_YES')" type="primary" class="meeting_button_primary" :disabled="buttonStatus">已保存</el-button>
                <el-button v-else-if="formtype&&Boolean(sendButtonStatus=='SEND_YES')" type="primary"  class="meeting_button_default" icon="el-icon-refresh" @click="refresh()" :disabled="buttonStatus">刷新</el-button>
                <el-button v-else type="primary" @click="saveBookForm('ruleForm')" class="meeting_button_default"  :loading="saveBtnLoading" :disabled="buttonStatus">{{Boolean(saveButtonStatus)?'已保存':'保存'}}</el-button>
            </div>
        </div>
        <el-dialog
            width="345px"
            title="扫描二维码"
            :visible.sync="innerVisible"
            :close-on-click-modal=false
            :before-close="handleClose"
            append-to-body>
            <img :src="weixincode" alt="二维码_石景山ODR">
            <div class="dialog-footer">
                <el-button type="primary" class="meeting_button_primary" @click="sendout('innerVisible')" :disabled="buttonStatus" :loading="BtnLoading">已经完成手写签名</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
// import areaselect from '@/module/index/pages/mediator/components/areaSelect'
import {getArbitrationBookByMediator, saveArbitrationBook, sendArbitrationBook, getProtocolBook, saveProtocolBook, sendMediationProtocolBook, savePromise, getMediationScheme, confirmSignature, getMediationClerkConfirm} from '@/api/meeting'
import areaSearch from '@/views/meeting/components/areaSearch/areaSearch.vue'
export default {
    props: ['resdata'],
    data() {
        return {
            saveBtnLoading:false,
            BtnLoading:false,
            dialogVisible: false,
            dialogType: '',
            diatorTitle: '',
            formtype: true,
            medbookbVisual: true,
            formaddress: {
                'NATURAL_PERSON':'常住地址',
                'JURIDICAL_PERSON':'单位地址',
                'UNINCORPORATED_ORGANIZATION':'机构地址'
            },
            caseId: '',
            meetingId: '',
            protocolBookData: {},
            promiseResponse: {},
            mediationSchemeResponse: '',
            weixincode: '',
            sendButtonStatus: null,
            saveButtonStatus: null,
            innerVisible: false,
            documentId: '',
            buttonStatus: false,
            caseUserName: [], // 存储未填写手机号的用户名
            confirmAll:false,
            helpMediatorCheckList: [],
            allApplicantCodeName:[],
            detailApplicantAddress:[],
            allResCodeName:[],
            detailResAddress:[]
        }
    },
    components: {
        areaSearch
    },
    mounted() {
        this.resdata.forEach(item => {
            this.helpMediatorCheckList.push(item)
        })
    },
    watch: {
        'resdata': {
            handler: function (newData, oldData) {
                newData.forEach(item => {
                    this.helpMediatorCheckList.push(item)
                })
            }
        }
    },
    methods: {
        openDialog(type,title,caseid, meetingID = null) {
            this.caseUserName = []
            this.caseId = caseid
            this.meetingId = meetingID
            this.dialogType = type
            this.diatorTitle = title
            this.dialogVisible = true
            if(type == "MEDIATION_BOOK") {
                this.getBookData('MEDIATION_BOOK')
            }else if(type == "NO_DISSENT_MEDIATION_SCHEME") {
                this.getScheme()
            }else if(type == 'UNDISPUTED_FACT') {
                this.getBookData('UNDISPUTED_FACT')
            }
        },
        refresh() {
            if(this.dialogType == "MEDIATION_BOOK") {
                this.getBookData('MEDIATION_BOOK')
            }else if(this.dialogType == "NO_DISSENT_MEDIATION_SCHEME") {
                this.getScheme()
            }else if(this.dialogType == 'UNDISPUTED_FACT') {
                this.getBookData('UNDISPUTED_FACT')
            }
        },
        currentPartyInfo (app,resp) {
            let partydata = app.concat(resp)
            partydata.forEach(item => {
                if(!Boolean(item.userId)) this.caseUserName.push(item.name)
            })
        },
        getBookData(type) {
            let applist=[],reslist=[]
            this.allApplicantCodeName = []
            this.detailApplicantAddress = []
            this.allResCodeName = []
            this.detailResAddress = []
            this.resetComponentAreaData()
            getArbitrationBookByMediator({
                caseId: this.caseId,
                meetingId: this.meetingId,
            }).then((res) => {
                if(res.data.code===1000){
                    this.protocolBookData = res.data.data;
                    res.data.data.applicantList.forEach((element) => {
                        this.allApplicantCodeName.push({
                            provName:element.provName,
                            provCode:element.provCode,
                            cityName:element.cityName,
                            cityCode:element.cityCode,
                            areaName:element.areaName,
                            streetName:element.streetName,
                            streetCode:element.streetCode
                        })
                        this.detailApplicantAddress.push( {
                            detailAddress:element.address,
                        })
                    })
                    res.data.data.respondentList.forEach((element) => {
                        this.allResCodeName.push({
                            provName:element.provName,
                            provCode:element.provCode,
                            cityName:element.cityName,
                            cityCode:element.cityCode,
                            areaName:element.areaName,
                            streetName:element.streetName,
                            streetCode:element.streetCode
                        })
                        this.detailResAddress.push({
                            detailAddress:element.address,
                        })
                    })
                    this.documentId = res.data.data.protocolId;
                    this.sendButtonStatus = res.data.data.sendStatus;
                    this.saveButtonStatus = res.data.data.protocolId;
                    if(!Boolean(res.data.data.protocolId)) this.formStatus();
                    this.currentPartyInfo(res.data.data.applicantList,res.data.data.respondentList)
                }else {
                    this.$message.error(res.data.message)
                }
            },(error)=>{
                console.log(error)
            })
        },
        getScheme() {
            let applist=[],reslist=[]
            this.resetComponentAreaData()
            getMediationScheme({
                "caseId": this.caseId
            }).then((res) => {
                if(res.data.code===1000){
                    this.medbookbVisual = res.data.data.promiseResponse?true:false;
                    this.promiseResponse = res.data.data.promiseResponse;
                    this.protocolBookData = res.data.data.mediationSchemeResponse;
                      res.data.data.mediationSchemeResponse.applicantList.forEach((element) => {
                        this.allApplicantCodeName.push({
                            provName:element.provName,
                            provCode:element.provCode,
                            cityName:element.cityName,
                            cityCode:element.cityCode,
                            areaName:element.areaName,
                            streetName:element.streetName,
                            streetCode:element.streetCode
                        })
                        this.detailApplicantAddress.push( {
                            detailAddress:element.address,
                        })
                    })
                    res.data.data.mediationSchemeResponse.respondentList.forEach((element) => {
                        this.allResCodeName.push({
                            provName:element.provName,
                            provCode:element.provCode,
                            cityName:element.cityName,
                            cityCode:element.cityCode,
                            areaName:element.areaName,
                            streetName:element.streetName,
                            streetCode:element.streetCode
                        })
                        this.detailResAddress.push({
                            detailAddress:element.address,
                        })
                    })
                    this.documentId = res.data.data.mediationSchemeResponse.protocolId;
                    this.sendButtonStatus = res.data.data.mediationSchemeResponse.sendStatus;
                    this.saveButtonStatus = res.data.data.mediationSchemeResponse.protocolId;
                    if(!Boolean(res.data.data.mediationSchemeResponse.protocolId)&&!this.medbookbVisual) this.formStatus();
                }else {
                    this.$message.error(res.data.message)
                }
            },(error)=>{
                console.log(error)
            })
        },
        saveBookForm(formName) {
            let self = this
            this.saveBtnLoading=true;
            this.buttonStatus =  true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (self.caseUserName.length) {
                        self.$confirm(self.caseUserName.join(',')+' 联系方式为固话，文书发起后无法收到并签署文书, 是否继续?', '提示', {
                            confirmButtonText: '继续',
                            cancelButtonText: '取消'
                        }).then(() => {
                            self.saveProtocolBookForm()
                        }).catch(() => {
                            self.$message({type: 'info',message: '已取消'})
                            self.buttonStatus =  false;
                            self.saveBtnLoading=false;
                        })
                    }else {
                        self.saveProtocolBookForm()
                    }
                } else {
                    this.buttonStatus =  false;
                    this.saveBtnLoading=false;
                    return false;
                }
            });
        },
        saveProtocolBookForm() {
            //仲裁调解书保存
            this.protocolBookData.meetingId = this.meetingId
            this.protocolBookData.documentType = this.dialogType
            let helpList = []
            this.helpMediatorCheckList.forEach(element => {
                helpList.push({
                    phone: element.mobilePhone,
                    userId: element.userId,
                    userName: element.userName
                })
            });
            this.protocolBookData.helpList = helpList

            saveArbitrationBook(this.protocolBookData).then((res) => {
                if(res.data.code == 1000) {
                    this.documentId = res.data.data.protocolId;
                    this.saveButtonStatus = res.data.data.protocolId;
                    this.protocolBookData = res.data.data;
                    this.formtype = true;
                    this.$message({message: '保存成功',type: 'success'})
                }else {
                    this.$message.error(res.data.message)
                }
                this.saveBtnLoading=false;
                this.buttonStatus =  false
            },(error) => {
                this.buttonStatus =  false;
                this.saveBtnLoading=false;
            })
        },
        savePromiseBook(formName) {
            this.buttonStatus =  true
            this.promiseResponse.caseId = this.caseId
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    savePromise(this.promiseResponse).then((res) => {
                        if(res.data.code===1000) {
                            this.medbookbVisual = false
                        }else {
                            this.$message.error(res.data.message)
                        }
                        this.buttonStatus =  false
                    })
                } else {
                    this.buttonStatus =  false
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        sendBookForm(formName) {
            let self = this
            this.buttonStatus =  true;
            this.BtnLoading=true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (self.caseUserName.length) {
                        self.$confirm(self.caseUserName.join(',')+' 联系方式为固话，文书发起后无法收到并签署文书, 是否继续?', '提示', {
                            confirmButtonText: '继续',
                            cancelButtonText: '取消'
                        }).then(() => {
                            self.sendProtocolBookTips()
                        }).catch(() => {
                            self.$message({type: 'info',message: '已取消'})
                            self.buttonStatus =  false;
                            self.BtnLoading =  false;
                        })
                    }else {
                        self.sendProtocolBookTips()
                    }
                } else {
                    this.BtnLoading =  false;
                    this.buttonStatus =  false
                    return false;
                }
            });
        },
        sendProtocolBookTips() {
            if(this.formtype){
                this.sendProtocolBookForm()
            }else {
                this.$confirm('发送的同时完成保存操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sendProtocolBookForm()
                }).catch(() => {
                    this.BtnLoading =  false;
                    this.buttonStatus =  false
                })
            }
        },
        sendProtocolBookForm() {
            this.protocolBookData.meetingId = this.meetingId
            this.protocolBookData.documentType = this.dialogType
            let helpList = []
            this.helpMediatorCheckList.forEach(element => {
                helpList.push({
                    phone: element.mobilePhone,
                    userId: element.userId,
                    userName: element.userName
                })
            });
            this.protocolBookData.helpList = helpList

            sendArbitrationBook(this.protocolBookData).then((res) => {
                if(res.data.code == 1000) {
                    this.$message({
                        message: '发送成功',
                        type: 'success'
                    });
                    this.documentId = res.data.data.protocolId
                    this.sendButtonStatus = res.data.data.sendStatus
                    this.$emit('comcallback',{type:this.dialogType})
                }else {
                    this.$message.error(res.data.message)
                }
                this.BtnLoading =  false;
                this.buttonStatus =  false;
            },(error) => {
                this.BtnLoading =  false;
                this.buttonStatus =  false;
            })
        },
        resetComponentAreaData() {
            this.protocolBookData = {}
        },
        comAreaBack(opt) {
            if(opt.type == "app") {
                this.protocolBookData.applicantList[opt.index].provCode = opt.code[0]
                this.protocolBookData.applicantList[opt.index].cityCode = opt.code[1]
                this.protocolBookData.applicantList[opt.index].areaCode = opt.code[2]
                this.protocolBookData.applicantList[opt.index].streetCode = opt.code[3]
                this.protocolBookData.applicantList[opt.index].provName = opt.names[0]
                this.protocolBookData.applicantList[opt.index].cityName = opt.names[1]
                this.protocolBookData.applicantList[opt.index].areaName = opt.names[2]
                this.protocolBookData.applicantList[opt.index].streetName = opt.names[3]
                this.protocolBookData.applicantList[opt.index].address = opt.address
            }else if(opt.type == "res"){
                this.protocolBookData.respondentList[opt.index].provCode = opt.code[0]
                this.protocolBookData.respondentList[opt.index].cityCode = opt.code[1]
                this.protocolBookData.respondentList[opt.index].areaCode = opt.code[2]
                this.protocolBookData.respondentList[opt.index].streetCode = opt.code[3]
                this.protocolBookData.respondentList[opt.index].provName = opt.names[0]
                this.protocolBookData.respondentList[opt.index].cityName = opt.names[1]
                this.protocolBookData.respondentList[opt.index].areaName = opt.names[2]
                this.protocolBookData.respondentList[opt.index].streetName = opt.names[3]
                this.protocolBookData.respondentList[opt.index].address = opt.address
            }
        },
        closeCurDialog() {
            this.dialogVisible = false
        },
        sendout() {
            this.BtnLoading=true
            this.buttonStatus =  true
            getMediationClerkConfirm({
                "docmentId": this.documentId,
                "lawCaseId": this.caseId,
            }).then((res) => {
                if(res.data.code === 1000) {
                    if(res.data.data.confirm){
                        this.innerVisible = false
                        this.dialogVisible = false
                        this.formtype = true
                        this.$emit('comcallback',{type:this.dialogType})
                    }else{
                        this.$message.error('还没有完成签名')
                    }
                }else {
                    if(res.data.message) this.$message.error(res.data.message)
                }
                this.BtnLoading=false
                this.buttonStatus =  false
            },(error) => {
                this.BtnLoading=false
                console.log("签名出错")
                this.buttonStatus =  false
            })
        },
        handleClose(done) {
            this.buttonStatus =  true
            getMediationClerkConfirm({
                "docmentId": this.documentId,
                "lawCaseId": this.caseId,
            }).then((res) => {
                if(res.data.code === 1000) {
                    if(res.data.data.confirm){
                        this.formtype = true
                        this.$emit('comcallback',{type:this.dialogType})
                    }else{
                        this.$message.error('还没有完成签名')
                    }
                }else {
                    if(res.data.message) this.$message.error(res.data.message)
                }
                done()
                this.buttonStatus =  false
            },(error) => {
                done()
                this.buttonStatus =  false
            })
        },
        formStatus() {
            this.formtype = false
            this.sendButtonStatus = null
            this.saveButtonStatus = null
        },
        mediatbookClose(done) {
            this.formtype = true
            this.$refs["ruleForm"] && this.$refs["ruleForm"].clearValidate()
            done()
        }
    }
}
</script>
<style lang="scss">
    .mediatbook {
        .caseno {
            height: 30px;
            margin-bottom: 12px;
            line-height: 30px;
            text-align: right;
            .el-input {
                width: 250px;
            }
            .el-input--small .el-input__inner {
                height: 30px;
                line-height: 30px;
            }
        }
        .md-head {
            height: 30px;
            margin-bottom: 12px;
            line-height: 30px;
            text-align: right;
            > span {
                float: left;
                font-size: 14px;
                font-weight: bold;
            }
            .el-input {
                width: 150px;
            }
            .el-input--small .el-input__inner {
                height: 30px;
                line-height: 30px;
            }
        }
        .md-wrap {
            .el-cascader {
                width: 100%
            }
            .applicantlist_line {
                padding-top: 10px;
                border-bottom: 1px dashed #e8e8e8
            }
        }
        .label_textalign {
            .el-form-item__label {
                line-height: 22px;
                text-align: left
            }
        }
        .signstatus {
            padding-bottom: 10px;
        }
        .md-otwrap {
            padding: 10px 0;
            label {
                padding: 10px 0;
            }
            label.label_other {
                display: block;
                padding-bottom: 20px;
            }
        }
        i.dialog_edit_icon {
            position:absolute;
             display: inline-block;
             top: 18px;
             right: 60px;
             width: 20px;
             height: 20px;
             background: url("../assets/img/dialog_edit.png") no-repeat center;
             cursor: pointer;
        }
    }
</style>

